module.exports = __webpack_public_path__ + "static/media/8.adce5381.png";